module.exports = __webpack_public_path__ + "img/cooperation_1.a92c9d3b.jpg";